import "./PCPMainPanel.scss";
import "./PCPMainPanelMobile.scss";

import AddressesComponent from "../Contents/Info & Settings/AddressesComponent/AddressesComponent";
import ProfileComponent from "../Contents/Info & Settings/ProfileComponent/ProfileComponent";
import ToPayComponent from "../Contents/Order History/ToPayComponent/ToPayComponent";
import UnpaidComponent from "../Contents/Order History/UnpaidComponent/UnpaidComponent";
import PartiallyPaidComponent from "../Contents/Order History/PartiallyPaidComponent/PartiallyPaidComponent";
import PendingApprovalComponent from "../Contents/Order History/PendingApprovalComponent/PendingApprovalComponent";
import DeclinedComponent from "../Contents/Order History/DeclinedComponent/DeclinedComponent";
import PaidComponent from "../Contents/Order History/PaidComponent/PaidComponent";
import ToReceiveOrdersComponent from "../Contents/Order History/ToReceiveOrdersComponent/ToReceiveOrdersComponent";
import CompleteOrderComponent from "../Contents/Order History/CompletedOrdersComponent/CompleteOrderComponent";
import CancelledOrdersComponent from "../Contents/Order History/CancelledOrdersComponent/CancelledOrdersComponent";
import RefundedOrderComponent from "../Contents/Order History/RefundedOrderComponent/RefundedOrderComponent";
import Wishlist from "../Contents/Wishlist/Wishlist";
import ChangePasswordComponent from "../Contents/Info & Settings/ChangePasswordComponent/ChangePasswordComponent";
function PCPMainPanel({ navId, sidebarId, navStructure }) {
  const componentMap = {
    AddressesComponent,
    ProfileComponent,
    UnpaidComponent,
    PendingApprovalComponent,
    PartiallyPaidComponent,
    PaidComponent,
    ToReceiveOrdersComponent,
    CompleteOrderComponent,
    CancelledOrdersComponent,
    DeclinedComponent,
    RefundedOrderComponent,
    Wishlist,
    ChangePasswordComponent,
    // add the rest here
  };

  // Find the current main nav item
  const currentNav = navStructure.find((nav) => nav.id === navId);

  // Find the sidebar item
  const currentSidebarItem = currentNav?.sidebar?.find(
    (item) => item.id === sidebarId
  );

  // Get the component name
  const ComponentName = currentSidebarItem
    ? componentMap[currentSidebarItem.component]
    : null;
  //console.log("ComponentName: ", navId + sidebarId);

  return (
    <>
      {navId === "reviews" || navId === "wishlist" ? (
        <div className="PMP-Container2">
          <div className="PMP-Wrapper">
            {ComponentName ? (
              <ComponentName />
            ) : (
              <p>Select an option to view content</p>
            )}
          </div>
        </div>
      ) : (
        <div className="PMP-Container">
          <div className="PMP-Wrapper ">
            {ComponentName ? (
              <ComponentName />
            ) : (
              <p>Select an option to view content</p>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default PCPMainPanel;
